import React from 'react';

const ForgotPassword = () => <div className="flex flex-1 bg-gray-500 h-screen" />



export default ForgotPassword;